import { render, staticRenderFns } from "./ConfiguratorTablist.vue?vue&type=template&id=3bbfe2fd"
import script from "./ConfiguratorTablist.vue?vue&type=script&lang=js"
export * from "./ConfiguratorTablist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports